export default "__VITE_ASSET__xh1TzBly__"